<template>
  <div class="avatar">
    <label for="avatar">
      <div class="avatar__cover"></div>
      <img :src="originalUrl" alt="" />
    </label>
    <div class="upload-avt-inp" @click="triggerUploadAvt">
      <div class="title">
        <i class="fas fa-camera text-white text-2xl"></i>
      </div>
      <input
        type="file"
        ref="avtUploadInp"
        class="hidden"
        @change="uploadImage"
        accept="image/*"
        id="avatar"
      />
    </div>
  </div>
</template>

<script>
import { postFileToS3 } from "@/helpers/aws-s3";
import { getUploadedImgUrl, initLoader } from "@/helpers/utils";

export default {
  props: ["defaultUrl", "s3FolderPath"],
  data() {
    return {
      tempUrl: ""
    };
  },
  computed: {
    originalUrl() {
      return this.tempUrl || this.defaultUrl || "img/avt_placeholder.jpg";
    }
  },
  methods: {
    triggerUploadAvt() {
      this.$refs.avtUploadInp.click();
    },
    async uploadImageToS3(file) {
      let loader = initLoader();

      return postFileToS3(this.s3FolderPath, file)
        .then(savedLink => {
          this.$emit("on-upload-s3-success", savedLink);
        })
        .finally(() => {
          loader.hide();
        });
    },
    async uploadImage(event) {
      try {
        const file = event.target.files[0];
        const imgUrl = await getUploadedImgUrl(file);

        if (!imgUrl) return;

        if (this.s3FolderPath) {
          await this.uploadImageToS3(file);
        }

        this.tempUrl = imgUrl;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  $avt-size: 246px;

  position: relative;
  width: $avt-size;
  height: $avt-size;
  border-radius: 50%;
  margin: auto;
  border: 2px solid #a3a3a3;

  label {
    .avatar__cover {
      position: absolute;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;

      border-radius: 50%;

      background: transparent;
      cursor: pointer;
      transition: 0.15s;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
    display: inline-block;
    border-radius: 50%;
    object-fit: cover;
  }

  .upload-avt-inp {
    position: absolute;
    bottom: 0;
    right: 30px;
    padding: 5px 10px;
    background: #929292;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.15s ease-in-out;

    &:hover {
      background: rgba(#929292, 0.8);
    }

    * {
      display: inline-block;
    }
  }
}
</style>
